import { createFileRoute } from '@tanstack/react-router';

import { HotelConfigPage } from '../modules/location-hotel-config/ui/pages/HotelConfigPage';

// NOTE: .index.tsx suffix is REQUIRED here (same pattern as niche-config + tariff + checkin-config).
// Without the .index suffix, TanStack Router treats the file as a layout component
// and wraps child routes instead of rendering the page. See JQ4-11 WU-13 gotcha.
export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/hotel-config/',
)({
  component: HotelConfigPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Hotel Configuration'],
  },
});
